import * as React from 'react';
import { observer } from 'mobx-react';

import { withLocalization } from '@shared-ui/localization-context';
import { Viewport, ViewSmall, ViewMedium } from '@shared-ui/viewport-context';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkLink } from 'uitk-react-link';
import { UitkText } from 'uitk-react-text';

import { FlightsSearchFormTravelersOption } from 'types/search/wizard';
import { LocalizedInteractableFieldComponentProps } from 'types/shared';
import { getSearchFormTriggerDateLabel } from 'utility';
import { useStores } from 'utility/hooks';
import { TravelerCountInfo } from '../';

interface SearchFormTriggerProps extends LocalizedInteractableFieldComponentProps {
  searchFormTriggerRef: React.MutableRefObject<HTMLInputElement>;
  openSearchForm: () => void;
}

export const SearchFormTrigger = withLocalization(
  observer(({ searchFormTriggerRef, l10n, openSearchForm }: SearchFormTriggerProps) => {
    const { searchFormStore } = useStores();
    const { currentOriginAndDestinationLocationsLabel, searchForm, searchFormInitialState } = searchFormStore;
    const departureAndReturnDates = searchForm && searchForm.departureAndReturnDates;

    const departureAndReturnDatesLabels = getSearchFormTriggerDateLabel(
      departureAndReturnDates,
      searchForm.journeys[0],
      searchFormInitialState,
      searchFormStore.loading,
      l10n
    );

    const travelerTypeOptions =
      searchForm &&
      searchForm.searchOptions &&
      (searchForm.searchOptions.find(
        searchOption => searchOption.__typename === 'FlightsSearchFormTravelersOption'
      ) as FlightsSearchFormTravelersOption);

    return (
      <div data-test-id="search-dialog-trigger">
        <UitkLink inline={true} onClick={openSearchForm} className="uitk-type-left">
          <button ref={searchFormTriggerRef}>
            <Viewport>
              <ViewSmall>
                <UitkLayoutGrid columns={1}>
                  <UitkLayoutGridItem>
                    <UitkText size={500} weight="bold" overflow="truncate">
                      {currentOriginAndDestinationLocationsLabel}
                    </UitkText>
                  </UitkLayoutGridItem>
                  <UitkLayoutGridItem>
                    <UitkText size={300} overflow="truncate">
                      {departureAndReturnDatesLabels.shortMessage}
                    </UitkText>
                  </UitkLayoutGridItem>
                </UitkLayoutGrid>
              </ViewSmall>
              <ViewMedium>
                <UitkLayoutGrid columns={1}>
                  <UitkLayoutGridItem>
                    <UitkText size={500} weight="bold" overflow="truncate">
                      {currentOriginAndDestinationLocationsLabel}
                    </UitkText>
                  </UitkLayoutGridItem>
                  <UitkLayoutGridItem>
                    <UitkText size={300} overflow="truncate">
                      {departureAndReturnDatesLabels.longMessage}
                      <TravelerCountInfo travelerTypeOptions={travelerTypeOptions} />
                    </UitkText>
                  </UitkLayoutGridItem>
                </UitkLayoutGrid>
              </ViewMedium>
            </Viewport>
          </button>
        </UitkLink>
      </div>
    );
  })
) as React.ComponentClass<SearchFormTriggerProps>;
